export const noop = () => {
  return undefined;
};

export const checkDashResult = (value: string | undefined): string => {
  if (value === undefined) {
    return '';
  }
  return value === '-' ? '' : value;
};
